module.exports = __webpack_public_path__ + "2c8915b2f6f7660327730b9219ab2a7f.obj";